import { timelineData } from "../../../mocks/anime";

const dayOrder = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-8 text-center md:mb-10">
          <p className="mb-2 text-xs font-bold tracking-widest text-primary-600">追番时间表</p>
          <h2 className="font-display text-2xl text-foreground-950 md:text-4xl">
            一周追番，不落任何一集
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            跟随女神动漫追番时间表，掌握每周热番播出节奏，甜番好戏一次追个够。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-7">
          {dayOrder.map((day) => {
            const item = timelineData.find((t) => t.day === day);
            return (
              <div
                key={day}
                className={`rounded-lg p-4 text-center ${
                  item
                    ? "bg-gradient-to-br from-secondary-100 to-accent-100"
                    : "bg-background-100"
                }`}
              >
                <p className="text-xs font-bold text-foreground-700">{day}</p>
                {item ? (
                  <>
                    <div className="mx-auto my-3 h-px w-8 bg-accent-500"></div>
                    <p className="font-display text-sm text-foreground-950">{item.title}</p>
                    <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-bold text-white">
                      {item.tag}
                    </span>
                    <p className="mt-2 text-xs text-foreground-500">
                      <i className="ri-time-line mr-1"></i>
                      {item.time}
                    </p>
                  </>
                ) : (
                  <p className="mt-3 text-xs text-foreground-400">暂无更新</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}